import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/reset.css'
import VueProgressBar from 'vue-progressbar'

import List from '@/components/list'
Vue.component(List.name, List)
Vue.use(ElementUI)
Vue.use(VueProgressBar, {
  color: '#1E009B',
  failedColor: 'red',
  height: '2px'
})
Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
